__turbopack_context__.v({
  "avatar": "BottomNav-module-scss-module__bbVPAq__avatar",
  "navMobile": "BottomNav-module-scss-module__bbVPAq__navMobile",
});
